import { createHasSessionAuthenticationSelector } from '../session';

export const selectCanAccessEula = createHasSessionAuthenticationSelector();